export const FREE_SHIPPING_THRESHOLD_US_CA = 49;
